import { useQuery } from "react-query";
import axios from "axios";
import { useState, useRef, useEffect } from "react";
import "./sectionend.scss";
import Loader from "../components/loader";
import LoadError from "../components/error";
import { ApiEndpoint } from "../components/utils";
import { pageIds } from "../components/utils";
import AppHeader from "../components/appheader";
import { BrandButton } from "../components/form/buttons";
import { useNavigate } from "react-router-dom";
import { getAppInfo, getCurrentSectionandQuestion, updateCurrentExamData } from "../components/user";

interface PageResponse {
  headerTitle?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  welcomeMessage?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  breakMessage?: any;
}

const SectionEnd = () => {
  const navigate = useNavigate();
  const showTimer = useRef(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let interval: any = null;
  const [seconds, setSeconds] = useState("00");
  const [minutes, setMinutes] = useState("0");
  const secondsRemainig = useRef(0);
  const [data, setdata] = useState<PageResponse | null>();
  const { isLoading, error } = useQuery("registerPageData", async () => {
    const resp = await axios.get(
      ApiEndpoint +
        "wp-json/satapp-api/v1/getPageText?slug=" +
        pageIds.section_end
    );
    setdata(resp.data as PageResponse);
  });
  const appData = getAppInfo();
  const { currentSectionId } = getCurrentSectionandQuestion();
  const examData = getAppInfo()?.currentExamData;

  showTimer.current = appData?.configData?.breakTime[currentSectionId as number] !== 0 ? true : false;

  const continueNextSection = () => {
    updateCurrentExamData(examData?.examId as number, {
      lastQuestionAnswered: examData?.examAnswers[currentSectionId as number].questions[0].questionId,
    });
    navigate("/question/" + examData?.examAnswers[currentSectionId as number].questions[0].questionId, { replace: true });
  };

  const startTimer = () => {
    let seconds = (appData && appData.configData) ? appData?.configData?.breakTime[currentSectionId as number] / 1000 : 0;
    secondsRemainig.current = seconds;
    interval = setInterval(function () {  
      setMinutes(Math.floor(seconds / 60).toString());
      const tempSeconds = seconds % 60;
      const formattedSeconds =
        tempSeconds < 10 
          ? "0" + tempSeconds.toString()
          : tempSeconds.toString();
      setSeconds(formattedSeconds);
      seconds--;    
      secondsRemainig.current = seconds;
      if (seconds <= -1) {
        clearInterval(interval); 
      }
    }, 1000);
  };

  useEffect(() => {
    if (showTimer.current) startTimer();
    return () => {
      clearInterval(interval);
    };
  }, []);
 
  if (isLoading) return <Loader />;
  if (error) return <LoadError />;

  return (
    <div className="sectionEndPage">
      <div className="headerHolder">
        <AppHeader timer={false} />
      </div>
      <div className="pageHeader">
        <h1>{data?.headerTitle}</h1>
      </div>
      <div className="pageContent">
        {secondsRemainig.current >= 0 ? (
          <div>
            <div dangerouslySetInnerHTML={{ __html: data?.breakMessage }} />
            <div className="timerHolder">
              {" "}
              {minutes}:{seconds} Minutes {}
            </div>
          </div>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: data?.welcomeMessage }} />
        )}
        <div className="btnHolder">
          <BrandButton
            disabled={secondsRemainig.current >= 0}
            onClick={continueNextSection}
          >
            Continue
          </BrandButton>
        </div>
      </div>
    </div>
  );
};

export default SectionEnd;
